import { h } from 'preact';
import boss from './boss.jpg';

const FinishPage = ({ onShowResult }) => {
  return h(
    'div',
    { className: 'container' },
    h('img', {
      src: boss,
      className: 'image',
      width: 512,
      height: 512,
    }),
    h('p',
      { className: 'examiner-message' },
      'ご苦労だった。それではこれから結果を通知する。'
    ),
    h(
      'button',
      { onClick: onShowResult, className: 'button' },
      '結果を見る'
    )
  );
};

export default  FinishPage



/** WEBPACK FOOTER **
 ** ./src/FinishPage.js
 **/